import pibFRPreview from 'images/pib_fr_preview.jpg';
import pibDEPreview from 'images/pib_de_preview.jpg';
import pibESPreview from 'images/pib_es_preview.jpg';
import pibENPreview from 'images/pib_en_preview.jpg';
import previewImage from 'images/link-preview.png';

const LOCALE_IMAGES: Record<string, string> = {
  de: pibDEPreview,
  en: pibENPreview,
  es: pibESPreview,
  fr: pibFRPreview,
};

export const getPreviewImage = (sourceLanguageLocale: string) => {
  return LOCALE_IMAGES[sourceLanguageLocale] || previewImage;
};
